// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --background: var(--ion-color-light-tint);
}

ion-col {
  display: flex;
  justify-content: center;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.badge {
  background-color: var(--ion-color-success);
  color: white;
  border-radius: 1em;
  font-size: 0.8em;
  position: absolute;
  margin-left: 1.8em;
  padding: 0.3em;
}`, "",{"version":3,"sources":["webpack://./src/app/common/sharedComponents/footer-button/footer-button.component.scss"],"names":[],"mappings":"AAAA;EACE,yCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,cAAA;AAAF","sourcesContent":[":host {\r\n  --background: var(--ion-color-light-tint);\r\n\r\n}\r\nion-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-left: 0.5em;\r\n  margin-right: 0.5em;\r\n}\r\n\r\n.badge{\r\n  background-color: var(--ion-color-success);\r\n  color: white;\r\n  border-radius: 1em;\r\n  font-size: 0.8em;\r\n  //font-weight: bold;\r\n  position: absolute;\r\n  margin-left: 1.8em;\r\n  padding: 0.3em;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
